class SafeTimeout {
    timeouts;

    constructor () {
      this.timeouts = []
    }

    setTimeout (callback, delay, ...args) {
      const newTimeout = window.setTimeout(
        () => {
          this.timeouts = this.timeouts.filter(timeout => timeout !== newTimeout)
          callback(args)
        },
        delay
      )
      this.timeouts.push(newTimeout)
    }

    clearTimeouts () {
      this.timeouts.forEach((timeout) => {
        window.clearTimeout(timeout)
      })
    }
}

export default SafeTimeout
